import { render } from "./ProximaTurma.vue?vue&type=template&id=76f37c0d&scoped=true"
import script from "./ProximaTurma.vue?vue&type=script&lang=js"
export * from "./ProximaTurma.vue?vue&type=script&lang=js"

import "./ProximaTurma.vue?vue&type=style&index=0&id=76f37c0d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f37c0d"]])

export default __exports__